var React = require('react');

function MicrophoneBgInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M520 0.799988H0V550.8H520V0.799988Z","fill":"#DD573C"}));
}

MicrophoneBgInline.defaultProps = {"width":"520","height":"551","viewBox":"0 0 520 551","fill":"none"};

module.exports = MicrophoneBgInline;

MicrophoneBgInline.default = MicrophoneBgInline;
